<template>
  <div class="detail">
    <div class="title"><span>人物</span><span> > {{data.title}}</span></div>
    <div class="info">
      <div class="left">
        <div class="avatar"><img :src="data.path" alt="" srcset=""></div>
        <div class="name">{{data.title}}</div>
        <div class="desc">{{data.description}}</div>
      </div>
      <ul class="right">
        <li v-for="(item, index) in list">
          <div @click="imgPreview(index)"><img :src="item.path" alt="" srcset=""></div>
          <span>{{item.title}}</span>
        </li>
      </ul>
    </div>
    <div class="clear"></div>
    <img-preview :list="list" ref="imgPreview"></img-preview>
  </div>
</template>

<script>
import imgPreview from '@/components/ImgPreview/Index.vue'
export default {
  name: 'CharacterDetail',
  components: {
    imgPreview
  },
  data() {
    return {
      id: '',
      data: {},
      list: []
    }
  },
  created() {
    this.id = this.$route.query.id
    console.log(this.id);
    this.loadData(this.id)
    this.getList(this.id)
  },
  methods: {
    loadData(id) {
      this.$http.get('/People/getPeopleInfo', {
        params: {
          id
        }
      })
        .then(response => {
          console.log(response.data);
          this.data = response.data.data
        })
    },
    getList(id) {
      this.$http.get('/People/getPeopleOpus', {
        params: {
          id,status:1
        }
      })
        .then(response => {
          this.list = response.data.data
        })
    },
    imgPreview(index) {
      this.$refs.imgPreview.show(index)
    }
  }
}
</script>

<style lang='less' scoped>
.detail {
  width: 980px;
  margin: 0 auto;
}
.clear {
  clear: both;
}
.title {
  font-size: 26px;
  font-weight: bold;
  line-height: 60px;
  span:nth-child(1) {
    display: inline-block;
    width: 55px;
    border-bottom: 3px solid red;
  }
  span:nth-child(2) {
    display: inline-block;
    width: 915px;
    padding-left: 10px;
    font-size: 16px;
    vertical-align: middle;
    font-weight: normal;
    color: #333;
    border-bottom: 3px solid #ccc;
    -moz-user-select: none;
    -khtml-user-select: none;
    user-select: none;
  }
}
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
.info {
  margin-top: 30px;
  .left {
    width: 250px;
    float: left;
    border-right: 1px solid #f0f0f0;
    .avatar {
      width: 200px;
      height: 200px;
      border-radius: 50%;
      overflow: hidden;
      text-align: center;
      margin: 0 auto;
    }
    .name {
      width: 100%;
      font-size: 20px;
      text-align: center;
      margin: 15px 0;
    }
    .desc {
      font-size: 14px;
    }
  }
  .right {
    float: left;
    width: 700px;
    margin-left: 20px;
    li {
      width: 160px;
      height: 200px;
      float: left;
      margin-right: 20px;
      img {
        width: 160px;
        height: 160px;
        border-radius: 10px;
      }
      &:nth-child(4n) {
        margin-right: 0;
      }
    }
  }
}
</style>
